// export const API_URI="https://wokeyebackend.azurewebsites.net/";  //for production
export const API_URI="http://localhost:5000/";  //for development